// extracted by mini-css-extract-plugin
export default {"list":"UlxaV9Fq5q4xlfGaZHN3","pulse":"kecibtY2poXj3xUI3lvo"};